<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <iq-card>
          <template v-slot:headerTitle v-if="!propOpenedInModal">
            <h4 class="card-title">{{cvCardTitle}}</h4>
          </template>
          <template v-slot:body>
            <p v-show="!propOpenedInModal">{{cvCardSubHeader}}</p>
            <form action="#" v-if="vmGpath_skill_recoFormData && Object.keys(vmGpath_skill_recoFormData).length > 0">
              <div class="form-row">
                <div class="col-md-12 mb-3">
                  <label for="validationskill_name">
                    {{cvSkillNameLabel}}</label
                  >
                  <input
                    v-model="vmGpath_skill_recoFormData.skill_name"
                    type="text"
                    class="form-control"
                    required
                  />
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationskill_desc">
                    {{cvSkillDescLabel}}</label
                  >
                  <textarea
                    v-model="vmGpath_skill_recoFormData.skill_desc"
                    type="text"
                    class="form-control textarea"
                    required>
                  </textarea>
                </div>
              </div>
              <div class="form-group">
                <button v-if="cvLoadingStatus" type="button" class="btn btn-primary" :disabled="cvLoadingStatus">
                   <b-spinner label="Spinning"></b-spinner>
                </button>
                <button type="button" class="btn btn-primary" @click="gpath_skill_recoEdit()">{{cvSubmitBtn}}</button>
              </div>
            </form>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>

<script>
import { gpathSkillRecos } from "../../../FackApi/api/GpathSkillReco.js"
import ApiResponse from "../../../Utils/apiResponse"
import { socialvue } from "../../../config/pluginInit"

export default {
  name: "gpathSkillRecoEdit",
  props: {
    propOpenedInModal: {
      type: Boolean,
      default: false
    },
    propGpath_skill_recoObj: {
      type: Object,
      default: function () {
        return {
          "skill_name": "",
          "skill_desc": ""
        }
      }
    }
  },
  data () {
    return {
      cvCardTitle: "Edit GPath Skill Reco",
      cvCardSubHeader: "Edit GPath Skill Reco",
      cvSubmitBtn: "Edit",
      cvSkillNameLabel: "skill name",
      cvSkillDescLabel: "skill desc",
      showToast: false,
      cvLoadingStatus: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "GPath Skill Reco Updated",
      vmGpath_skill_recoFormData: {}
    }
  },
  mounted () {
    socialvue.index()
    this.gpath_skill_recoView()
  },
  methods: {
    /**
     * validate
     */
    validate () {
      try {
        for (let index in this.vmGpath_skill_recoFormData) {
          if (!this.vmGpath_skill_recoFormData[index]) {
            this.toastMsg = "Missing " + index.split("_").join(" ")
            this.toastVariant = "danger"
            this.showToast = true
            return false
          }
        }
        return true
      }
      catch (err) {
        console.error("Exception occurred at validate() and Exception:", err.message)
        return null
      }
    },
    /**
     * gpath_skill_recoView
     */
    async gpath_skill_recoView () {
      try {
        if (this.propOpenedInModal) {
          this.vmGpath_skill_recoFormData = this.propGpath_skill_recoObj
        }
        else {
          let gpathSkillRecoId = this.$route.params.gpsr_id
          let gpathSkillRecoViewResp = await gpathSkillRecos.gpath_skill_recoView(this, gpathSkillRecoId)

          if (gpathSkillRecoViewResp && gpathSkillRecoViewResp.resp_status) {
            this.vmGpath_skill_recoFormData = gpathSkillRecoViewResp.resp_data.data
          }
        }
      }
      catch (err) {
        console.error("Exception occurred at gpath_skill_recoView() and Exception:", err.message)
      }
    },
    /**
     * gpath_skill_recoEdit
     */
    async gpath_skill_recoEdit () {
      try {
        // if (!this.validate()) {
        //   return false
        // }
        this.cvLoadingStatus = true
        let gpathSkillRecoAddResp = await gpathSkillRecos.gpath_skill_recoEdit(this, this.vmGpath_skill_recoFormData)
        await ApiResponse.responseMessageDisplay(this, gpathSkillRecoAddResp)

        if (gpathSkillRecoAddResp && !gpathSkillRecoAddResp.resp_status) {
          return false
        }

        //  Emit if opened in Modal
        if (this.propOpenedInModal) {
          this.$emit("emitCloseGpath_skill_recoEditModal", this.vmGpath_skill_recoFormData)
        }
      }
      catch (err) {
        console.error("Exception occurred at gpath_skill_recoEdit() and Exception:", err.message)
      }
      finally {
        this.cvLoadingStatus = false
      }
    }
  }
}
</script>
<style scoped>
 textarea{
    height: 195px !important;
    overflow-y: scroll;
    line-height: 18px !important;
  }
</style>
